import { isSummaryContent } from "@/types/summary";
const summaryContents = [];
export const useSharedAiSummary = () => {
    const registerSummaryContent = (ref) => summaryContents.push(ref);
    // Due to a bug in 1.59 it's possible for old AiContent to have duplicate requestId values
    // We want to be able to detect these situations and disable certain functionality that relies on having a unique requestId
    const isRequestIdUnique = (contentId, requestId) => !summaryContents.some((r) => {
        const c = r.value;
        return c && isSummaryContent(c) && c.contentId !== contentId && c.requestId === requestId;
    });
    return { registerSummaryContent, isRequestIdUnique };
};
